<!-- Note Header Container -->
<div class="note-header">

  <!-- Left Section: Title, Status, Project Info -->
  <div class="header-left">

    <!-- Title and Status Badge Row -->
    <div class="title-row">
      <h2 class="header-title">{{ getDisplayTitle() }}</h2>
      @if (status && mode === 'view') {
        <span
          class="status-badge"
          [ngStyle]="getStatusBadgeStyles()">
          {{ getFormattedStatus() }}
          @if (isStatusLocked) {
            <mat-icon
              class="status-lock-icon"
              inline="true">
              lock
            </mat-icon>
          }
        </span>
      }
    </div>

    <!-- Project Info Row -->
    @if (moduleLabel || projectName) {
      <div class="project-info">
        @if (moduleLabel) {
          <span class="info-label">{{ moduleLabel }}</span>
        }
        @if (moduleLabel && projectName) {
          <span class="separator">•</span>
        }
        @if (projectName) {
          @if (recordRoute) {
            <a class="info-value record-link" [routerLink]="recordRoute" (click)="recordLinkClick.emit()">{{ projectName }}</a>
          } @else {
            <span class="info-value">{{ projectName }}</span>
          }
        }
        @if (projectId && projectName) {
          <span class="separator">•</span>
        }
        @if (projectId) {
          @if (recordRoute) {
            <a class="project-id record-link" [routerLink]="recordRoute" (click)="recordLinkClick.emit()">#{{ projectId }}</a>
          } @else {
            <span class="project-id">#{{ projectId }}</span>
          }
        }
      </div>
    }

  </div>

  <!-- Right Section: Action Buttons -->
  <div class="header-actions">

    <!-- GROUP 1: Note-Specific Actions (Flag) -->
    <div class="action-group">
      <!-- Flag Toggle Button (Note-specific feature) -->
      <button
        mat-icon-button
        class="action-button"
        [class.flag-active]="flagged"
        (click)="onFlagToggle()"
        type="button"
        [attr.aria-label]="flagged ? 'Remove flag' : 'Add flag'"
        [matTooltip]="flagged ? 'Flagged (Click to remove)' : 'Flag this note'">
        <mat-icon>{{ flagged ? 'flag' : 'outlined_flag' }}</mat-icon>
      </button>
    </div>

    <!-- Divider after flag -->
    <div class="action-divider"></div>

    <!-- GROUP 2: Note Properties (Priority) -->
    <div class="action-group">
      <!-- High Priority Toggle Button -->
      <button
        mat-icon-button
        class="action-button priority-toggle-button"
        [class.priority-active]="isHighPriority"
        (click)="onPriorityToggle()"
        type="button"
        [attr.aria-label]="isHighPriority ? 'Remove high priority' : 'Set high priority'"
        [matTooltip]="isHighPriority ? 'High Priority (Click to remove)' : 'Set High Priority'">
        <mat-icon>local_fire_department</mat-icon>
      </button>
    </div>

    <!-- Divider after priority -->
    <div class="action-divider"></div>

    <!-- GROUP 3: View Mode Actions (Mark Complete, PDF) -->
    @if (mode === 'view' && noteId) {
      <div class="action-group">
        <!-- View Mode: Mark Complete Button -->
        <button
          mat-icon-button
          class="action-button action-button--success"
          (click)="onMarkComplete()"
          type="button"
          [attr.aria-label]="'Mark complete'"
          matTooltip="Mark Complete">
          <mat-icon>check_circle</mat-icon>
        </button>
        <!-- View Mode: PDF Export Button -->
        <button
          mat-icon-button
          class="action-button action-button--info"
          (click)="onExportPDF()"
          type="button"
          [attr.aria-label]="'Export PDF'"
          matTooltip="Export PDF">
          <mat-icon>description</mat-icon>
        </button>
      </div>
    }

    <!-- Divider after view mode actions -->
    @if (mode === 'view' && noteId) {
      <div class="action-divider"></div>
    }

    <!-- GROUP 4: Primary Actions (Edit) -->
    @if (mode === 'view' && noteId) {
      <div class="action-group action-group--primary">
        <!-- View Mode: Edit Button (raised button with text like task) -->
        <button
          mat-raised-button
          class="save-button"
          (click)="onEditNote()"
          type="button"
          [attr.aria-label]="'Edit note'"
          matTooltip="Edit note">
          <mat-icon>edit_note</mat-icon>
          <span class="button-text">Edit</span>
        </button>
      </div>
    }

    <!-- Divider before system actions -->
    @if (mode === 'view') {
      <div class="action-divider"></div>
    }

    <!-- GROUP 5: System Actions (Delete, Close) -->
    <div class="action-group action-group--system">
      <!-- Delete Button (Edit Mode Only) -->
      @if (mode === 'edit' && noteId) {
        <button
          mat-icon-button
          class="action-button action-button--danger"
          (click)="onDelete()"
          type="button"
          [attr.aria-label]="'Delete note'"
          matTooltip="Delete note">
          <mat-icon>delete_forever</mat-icon>
        </button>
      }

      <!-- Close Button -->
      <button
        mat-icon-button
        class="action-button"
        (click)="onClose()"
        type="button"
        [attr.aria-label]="'Close'"
        matTooltip="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>

  </div>

</div>

<!-- Animated Search Bar -->
@if (isSearchOpen) {
  <div class="search-bar-container" [@slideDown]>
    <div class="search-input-wrapper">
      <mat-icon class="search-icon">search</mat-icon>
      <input
        #searchInput
        type="text"
        class="search-input"
        placeholder="Search within this note..."
        [value]="searchQuery"
        (input)="onSearchInput($event)"
        (keyup.escape)="onSearch()"
        [attr.aria-label]="'Search within note'"
        autocomplete="off">
    </div>
  </div>
}
